import { WebPlatformApiService } from '../../services/WebPlatformApiService';
import { DataPolicy, WidgetConfiguration } from '../../interfaces/WidgetInterfaces';
import { DataRequestError } from '../../interfaces/DisplayInterfaces';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-data-error-display',
  template: `<tabset type="pills">
  <tab heading="Error">
    <table class="table table-striped table-sm">
      <thead>
        <tr class="table-danger">
          <td colspan="2">Data Retrieval Error</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="customMessage">
          <td colspan="2">{{customMessage}}</td>
        </tr>

        <tr *ngIf="dataRequestError && dataRequestError.widgetName">
          <td>Widget</td>
          <td>{{dataRequestError.widgetName}}</td>
        </tr>
        <tr *ngIf="matchingDataPolicy && matchingDataPolicy.supportGroup">
          <td>Data Support Group</td>
          <td>{{matchingDataPolicy.supportGroup}}</td>
        </tr>
        <tr *ngIf="matchingDataPolicy && matchingDataPolicy.supportMessage">
          <td>Data support Message</td>
          <td>{{matchingDataPolicy.supportMessage}}</td>
        </tr>
        <tr *ngIf="matchingDataPolicy && matchingDataPolicy.supportNameList">
          <td>Contact List</td>
          <td>{{matchingDataPolicy.supportNameList}}</td>
        </tr>
      </tbody>
    </table>
  </tab>
  <tab heading="Details">
    <table class="table table-striped table-sm">
      <thead>
        <tr class="table-danger">
          <td colspan="2">Data Retrieval Error</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="dataRequestError && dataRequestError.ErrorMessage">
          <td>Error Message</td>
          <td>{{dataRequestError.ErrorMessage}}</td>
        </tr>
        <tr *ngIf="dataRequestError && dataRequestError.dataPolicy">
          <td>data policy</td>
          <td>{{dataRequestError.dataPolicy}}</td>
        </tr>
        <tr *ngIf="dataRequestError && dataRequestError.RequestKey">
          <td>data key</td>
          <td>{{dataRequestError.RequestKey}}</td>
        </tr>
      </tbody>
    </table>
  </tab>
</tabset>`,
  styles: [``]
})
export class DataErrorDisplayComponent implements OnInit {

  @Input() dataRequestError: DataRequestError;
  @Input() parentConfig: WidgetConfiguration;
  @Input() customMessage: string = undefined;

  dataPolicyList: DataPolicy[] = [];
  matchingDataPolicy: DataPolicy;
  constructor(private webPlatformApiService: WebPlatformApiService) {
    this.webPlatformApiService.GetConfig<DataPolicy[]>('DataPolicyList').subscribe(x => {
      this.dataPolicyList = x;

      this.matchingDataPolicy = this.dataPolicyList.find(dp => dp.name === this.dataRequestError.dataPolicy);
    });
  }

  ngOnInit() {
    
  }

}
